import { Injectable } from '@angular/core';

declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}

@Injectable({
  providedIn: 'root'
})
export class MetaPixelService {
  private fbq(...args: any[]): void {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq(...args);
    }
  }

  pageView(): void {
    this.fbq('track', 'PageView');
  }

  track(eventName: string, params?: Record<string, any>): void {
    this.fbq('track', eventName, params || {});
  }

  trackCustom(eventName: string, params?: Record<string, any>): void {
    this.fbq('trackCustom', eventName, params || {});
  }
}
